import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import workProcessIcon from "../assets/icons/ic_workProgress_re.png";
import { useWorkProgressLogic } from "../hooks/logic/useTaskProgress";
import "./WorkProgress.scss";

const WorkProgress: React.FC = () => {
  const { statusCards, isLoading, error } = useWorkProgressLogic();

  if (isLoading) {
    return <div>読み込み中...</div>;
  }

  if (error) {
    return <div>エラーが発生しました: {error}</div>;
  }

  return (
    <Box className="work-progress-section" sx={{ flex: 4 }}>
      <Box className="bottom-title">
        <Typography className="title">
          <img src={workProcessIcon} alt="作業進捗状況アイコン" />
          作業進捗状況
        </Typography>
      </Box>
      <Grid container spacing={1} sx={{ ml: -3, mt: 3 }}>
        {statusCards.map((card) => (
          <Grid item xs={12} sm={6} md={2} key={card.id}>
            <Box className="status-card">
              {/* count部分をLinkでラップ */}
              <Link to={card.link} className="count-link">
                <img src={card.icon} alt="" />
                <Typography className="count-text">{card.count}</Typography>
              </Link>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WorkProgress;
